import { ProcessStep } from '../models/SuperThemProcess';
import { post } from '../utils/backend';
import { getMockData, mock } from './mock/Mock';
import './mock/SuperThemProcessMock';

const getAllProcessSteps = async (): Promise<ProcessStep[]> => {
  if (mock) {
    return getMockData("getAllProcessSteps");
  }
  
  const resultOrErrorCode = await post<{}, ProcessStep[]>("/process-steps", {});
  if (typeof resultOrErrorCode === 'string') {
    // 错误码处理
    return [];
  }
  return resultOrErrorCode;
};

const addProcessStep = async (step: ProcessStep): Promise<number> => {
  if (mock) {
    const processSteps: ProcessStep[] = getMockData("getAllProcessSteps");
    const newId = processSteps.length + 1;
    processSteps.push({ ...step, id: newId.toString() });
    return newId;
  }
  
  const resultOrErrorCode = await post<ProcessStep, { id: number }>("/process-steps", step);
  if (typeof resultOrErrorCode === 'string') {
    // 错误码处理
    throw new Error('添加流程步骤失败');
  }
  return resultOrErrorCode.id;
};

const deleteProcessStep = async (id: string): Promise<boolean> => {
  if (mock) {
    const processSteps: ProcessStep[] = getMockData("getAllProcessSteps");
    const index = processSteps.findIndex((step: ProcessStep) => step.id === id);
    if (index !== -1) {
      processSteps.splice(index, 1);
    }
    return true;
  }
  
  const resultOrErrorCode = await post<{ id: string }, boolean>(`/process-steps/${id}/delete`, { id });
  if (typeof resultOrErrorCode === 'string') {
    // 错误码处理
    return false;
  }
  return resultOrErrorCode;
};

export const SuperThemProcessApi = {
  getAllProcessSteps,
  addProcessStep,
  deleteProcessStep
}; 